// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListItem-ExtractorActions-module__reviewers";
var _2 = "webpack-pages-StudyList-StudyListItem-ExtractorActions-module__singleExtractorTable";
var _3 = "webpack-pages-StudyList-StudyListItem-ExtractorActions-module__suggestionBanner";
var _4 = "webpack-pages-StudyList-StudyListItem-ExtractorActions-module__table";
var _5 = "webpack-pages-StudyList-StudyListItem-ExtractorActions-module__tableHeading";
var _6 = "webpack-pages-StudyList-StudyListItem-ExtractorActions-module__tableHeadingContent";
var _7 = "webpack-pages-StudyList-StudyListItem-ExtractorActions-module__wrapper";
export { _1 as "reviewers", _2 as "singleExtractorTable", _3 as "suggestionBanner", _4 as "table", _5 as "tableHeading", _6 as "tableHeadingContent", _7 as "wrapper" }
